/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Parts_TitleInputs */

const en_ticket_parts_title = /** @type {(inputs: Ticket_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts`)
};

const ja_ticket_parts_title = /** @type {(inputs: Ticket_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品`)
};

const fr_ticket_parts_title = /** @type {(inputs: Ticket_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces`)
};

const de_ticket_parts_title = /** @type {(inputs: Ticket_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile`)
};

/**
* | output |
* | --- |
* | "Parts" |
*
* @param {Ticket_Parts_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_parts_title = /** @type {((inputs?: Ticket_Parts_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Parts_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_parts_title(inputs)
	if (locale === "ja") return ja_ticket_parts_title(inputs)
	if (locale === "fr") return fr_ticket_parts_title(inputs)
	return de_ticket_parts_title(inputs)
});